export default __webpack_public_path__ + "static/media/Grupo 154.d422bd21.svg";